import { Plus, Trash2 } from 'lucide-react';

const INP = {
  background: 'rgba(255,255,255,.05)',
  border: '1px solid rgba(201,168,76,.18)',
  borderRadius: 5,
  padding: '9px 12px',
  color: '#fff',
  width: '100%',
  fontSize: '.83rem',
  fontFamily: 'var(--sans)',
  outline: 'none',
  boxSizing: 'border-box',
};

const LBL = {
  fontSize: '.6rem',
  color: 'rgba(255,255,255,.36)',
  letterSpacing: '.1em',
  textTransform: 'uppercase',
  marginBottom: 4,
  display: 'block',
};

const EMPTY = { downPaymentPercent: '', installmentYears: '', notes: '' };

export default function PaymentPlanBuilder({ plans, onChange }) {
  const add    = () => onChange([...plans, { ...EMPTY }]);
  const remove = (i) => onChange(plans.filter((_, idx) => idx !== i));
  const patch  = (i, key, val) =>
    onChange(plans.map((p, idx) => idx === i ? { ...p, [key]: val } : p));

  return (
    <div>
      {plans.length === 0 && (
        <div style={{
          textAlign: 'center', padding: '1.2rem',
          color: 'rgba(255,255,255,.25)', fontSize: '.78rem',
          border: '1px dashed rgba(201,168,76,.15)', borderRadius: 6, marginBottom: 10,
        }}>
          No payment plans yet — click below to add one
        </div>
      )}

      {plans.map((p, i) => (
        <div key={i} style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr 2fr auto',
          gap: 10, alignItems: 'end', marginBottom: 10,
          background: 'rgba(255,255,255,.025)',
          border: '1px solid rgba(201,168,76,.1)',
          borderRadius: 6, padding: '12px',
        }}>
          <div>
            <label style={LBL}>Down Payment %</label>
            <input
              id={`payment-plan-${i}-downpayment`}
              name={`payment-plan-${i}-downpayment`}
              style={INP}
              type="number" min={0} max={100} placeholder="10"
              value={p.downPaymentPercent}
              onChange={e => patch(i, 'downPaymentPercent', e.target.value)}
            />
          </div>
          <div>
            <label style={LBL}>Years</label>
            <input
              id={`payment-plan-${i}-years`}
              name={`payment-plan-${i}-years`}
              style={INP}
              type="number" min={1} placeholder="7"
              value={p.installmentYears}
              onChange={e => patch(i, 'installmentYears', e.target.value)}
            />
          </div>
          <div>
            <label style={LBL}>Notes (optional)</label>
            <input
              id={`payment-plan-${i}-notes`}
              name={`payment-plan-${i}-notes`}
              style={INP}
              type="text" placeholder="e.g. No interest"
              value={p.notes}
              onChange={e => patch(i, 'notes', e.target.value)}
            />
          </div>
          <button
            onClick={() => remove(i)}
            style={{
              background: 'rgba(248,113,113,.1)',
              border: '1px solid rgba(248,113,113,.25)',
              borderRadius: 5, padding: '9px 10px',
              cursor: 'pointer', color: '#f87171',
              display: 'flex', alignItems: 'center',
            }}
          >
            <Trash2 size={13} />
          </button>
        </div>
      ))}

      <button
        onClick={add}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          background: 'rgba(201,168,76,.08)',
          border: '1px dashed rgba(201,168,76,.35)',
          borderRadius: 5, padding: '8px 16px',
          color: 'var(--gold)', cursor: 'pointer',
          fontSize: '.8rem', fontFamily: 'var(--sans)',
          width: '100%', justifyContent: 'center',
        }}
      >
        <Plus size={13} /> Add Payment Plan
      </button>
    </div>
  );
}
